import { Component, Element, Prop, h } from '@stencil/core';

import { AutoCheckState } from '../../../store/store.autocheck';
import { OfferState } from '../../../store/store.offer';
import { OfferDetailsModal } from '../offer-details-modal/offer-details-modal';

const LOCAL_DEALER_URL: string = 'https://www.kbb.com/find-trade-in-dealer/';
const START_BROWSING_URL: string = 'https://www.kbb.com/new-cars/';
const PLACE_AD_URL: string = 'https://www.autotrader.com/sell-my-car/ads/packages';

@Component({
  tag: 'offer-certificate-ineligible',
  styleUrl: 'offer-certificate-ineligible.css',
})
export class OfferCertificateIneligible {
  @Element() el: HTMLElement;
  @Prop() termsAndConditionsUrl: string = '';

  @Prop() autoCheck: AutoCheckState;

  @Prop() customer = { email: '', firstName: '', lastName: '', phone: '', zip: '' };

  @Prop() dealer = {
    allocated: [],
    dealerOffers: {},
    buyingCenters: [],
    isOfficeClosed: false,
    name: '',
  };

  @Prop() offer: OfferState;

  @Prop() vehicle = {
    accidents: false,
    auctionedRecently: false,
    color: '',
    description: '',
    drivetrain: '',
    engine: '',
    fullName: '',
    hasReplacement: false,
    hasTwoSetsOfKeys: true,
    imageUrl: '',
    offerOptions: [],
    isAuctionedLast45: false,
    isRental: false,
    mileage: 0,
    originalOwner: false,
    rentalVehicle: false,
    replacementName: '',
    replacementText: '',
    replacementTypes: '',
    replacementVehicleYearMax: 2023,
    replacementVehicleYearMin: 2018,
    transmission: '',
    vin: '',
    yearMakeModel: '',
    yearId: 0,
    makeId: 0,
    modelId: 0,
    trimId: 0,
  };

  @Prop() showVehicleDetailDialog: (e: MouseEvent) => void = () => {};

  render() {
    const { autoCheckFullReportLink, hasAccidents, hasPriorRentals, hasSingleOwner, reportDate, historyIcons } = this.autoCheck;
    const { email, zip } = this.customer;
    const { accidentQuestionModifiedByDealer, offerId, showCustomerIneligibleNextSteps, useTradeIn, tradeInBtnText, isKelleyBuysYourCar } = this.offer;
    const { fullName, vin } = this.vehicle;

    const hasVehicleHistory = autoCheckFullReportLink.length > 1;
    const showKelleyBuysYourCar = isKelleyBuysYourCar;

    return (
      <certificate-layout>
        <offer-ineligible
          offerId={offerId}
          consumerEmail={email}
          useTradeInButtonText={tradeInBtnText}
          consumerZip={zip}
          vehicleName={fullName}
          whenReviewVehicleDetailsClicked={this.showVehicleDetailDialog.bind(this)}
          slot="hero"
          useTradeIn={useTradeIn}
          showKelleyBuysYourCar={showKelleyBuysYourCar}
        />

        {!showKelleyBuysYourCar && hasVehicleHistory && (
          <vehicle-history-report
            autoCheckFullReportLink={autoCheckFullReportLink}
            hasDealerEditedQuestion={accidentQuestionModifiedByDealer}
            hasAccidents={hasAccidents}
            hasPriorRentals={hasPriorRentals}
            hasSingleOwner={hasSingleOwner}
            reportGeneratedOnDate={reportDate}
            vin={vin}
            slot="hero"
            historyIcons={historyIcons}
          />
        )}

        {!showKelleyBuysYourCar && showCustomerIneligibleNextSteps && (
          <ineligible-next-steps slot="main" vehicleName={fullName} localDealerUrl={LOCAL_DEALER_URL} startBrowsingUrl={START_BROWSING_URL} placeAdUrl={PLACE_AD_URL} />
        )}

        <div class="text-center mb-14">
          <h2 class="text-xl mb-1">What makes a vehicle ineligible?</h2>
          <div class="text-sm mb-4">It could be a lot of things.</div>
          <ul class="font-bold mb-0 text-left w-3/4 m-auto">
            <li class="mb-3">Some vehicles are rare, so there aren't enough vehicles for a good sales history.</li>
            <li class="mb-3">Certain equipment (especially vehicle modifications) can make a vehicle ineligible.</li>
            <li class="mb-3">Or maybe the vehicle has title issues, poor condition, or mileage over 300,000.</li>
          </ul>
        </div>

        <OfferDetailsModal shouldShowDealerComments={false} autoCheck={this.autoCheck} customer={this.customer} offer={this.offer} vehicle={this.vehicle} />

        <offer-certificate-disclaimer />
      </certificate-layout>
    );
  }
}
